import React from "react";
import { Link } from "gatsby";
import styled from "styled-components";

const PillButtonLinkFilledStyles = styled.button`
  display: inline-block;
  height: 48px;
  border-radius: 100px;
  outline: none;
  font-family: var(--header-font);
  font-size: 18px;
  line-height: 47px;
  cursor: pointer;
  padding: 0 40px;
  border: none;
  color: white;
  background: var(--off-black);

  &:hover,
  &:active {
    background: white;
    color: var(--off-black);
    border: 1.5px solid var(--off-black);
  }
`;

const PillButtonLinkNeonStyles = styled.button`
  display: inline-block;
  height: 48px;
  border-radius: 100px;
  outline: none;
  font-family: var(--header-font);
  font-size: 18px;
  line-height: 47px;
  cursor: pointer;
  padding: 0 40px;
  border: 1px solid var(--off-black);
  color: var(--off-black);
  background: var(--neon-yellow);

  &:hover,
  &:active {
    background: transparent;
    color: var(--off-black);
    border: 1.5px solid var(--off-black);
  }
`;

const PillButtonLinkUnfilledStyles = styled.button`
  display: inline-block;
  height: 48px;
  border-radius: 100px;
  outline: none;
  font-family: var(--header-font);
  font-size: 18px;
  color: var(--off-black);
  line-height: 47px;
  cursor: pointer;
  padding: 0 40px;
  border: 1.5px solid var(--off-black);
  background: transparent;

  &:hover,
  &:active {
    background: var(--off-black);
    color: white;
    border: none;
  }
`;

const PillButtonLink = ({
  targetUrl,
  buttonText,
  buttonStyle,
  externalUrl,
}) => {
  if (externalUrl)
    return (
      <a href={externalUrl}>
        <PillButtonLinkUnfilledStyles>
          {buttonText}
        </PillButtonLinkUnfilledStyles>
      </a>
    );
  else if (buttonStyle === "neon")
    return (
      <Link to={targetUrl}>
        <PillButtonLinkNeonStyles>{buttonText}</PillButtonLinkNeonStyles>
      </Link>
    );
  else
    return buttonStyle === "filled" ? (
      <Link to={targetUrl}>
        <PillButtonLinkFilledStyles>{buttonText}</PillButtonLinkFilledStyles>
      </Link>
    ) : (
      <Link to={targetUrl}>
        <PillButtonLinkUnfilledStyles>
          {buttonText}
        </PillButtonLinkUnfilledStyles>
      </Link>
    );
};

export default PillButtonLink;
